//import navItemsV2 from "lib/nav-items-v2";
//import NavigationCards from "../../navigation/navigation-cards/navigation-cards";
//import navItems from "lib/nav-items";
import { useContext, useMemo } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
//import { INavItemV2, INavigationCardItem } from "@interfaces/common.interfaces";
import NavigationCards from "components/navigation/navigation-cards/navigation-cards";
import { getNavigationCardItems } from "lib/utils";
import NavigationCards2 from "components/navigation/navigation-cards/navigation-cards2";


// TODO: <PaddedContent>...</PaddedContent>


export default function ReportsIndex() {

    const location = useLocation();

    return (
        <NavigationCards2 route={location.pathname} />
    );
}
